/** Local invalidation signal only; never carries permission values or client data. */
const listeners = new Set<() => void>();
export function requestAccessRefresh() {
  listeners.forEach(listener => listener());
}
export function subscribeAccessRefresh(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

/** The same signal for a salon setup change: its listener sits inside the salon's cache, out of the sender's reach. */
const setupListeners = new Set<() => void>();
export function requestSalonSetupRefresh() {
  setupListeners.forEach(listener => listener());
}
export function subscribeSalonSetupRefresh(listener: () => void) {
  setupListeners.add(listener);
  return () => { setupListeners.delete(listener); };
}
